import { Fragment } from 'react';
import { VelocityMarquee } from './fx/VelocityMarquee';
import { Paw, Heart } from './brand/Shapes';

const SERVICES = ['Banho', 'Tosa higiênica', 'Tosa completa', 'Passeios', 'Pacotes mensais'];
const VALUES = ['Carinho', 'Qualidade', 'Confiança', 'Jardim Alegre/PR'];

const Row = ({ items, Icon, iconClass }) => (
  <div className="flex items-center shrink-0">
    {items.map((item) => (
      <Fragment key={item}>
        <span className="px-5 md:px-8">{item}</span>
        <Icon className={iconClass} />
      </Fragment>
    ))}
  </div>
);

/** Duas fitinhas cruzadas (azul e rosa), como as de um laço. */
export const Marquee = () => (
  <section aria-label="Serviços" className="relative py-14 md:py-20 overflow-hidden bg-pet-cream">
    <div className="relative -rotate-[3deg] scale-[1.06] bg-pet-blue text-white py-3 md:py-4 shadow-[0_16px_30px_-18px_rgba(47,116,224,0.8)] z-10">
      <VelocityMarquee baseVelocity={-2.2}>
        <div className="font-display text-[2rem] md:text-[3.6rem] leading-none">
          <Row items={SERVICES} Icon={Paw} iconClass="w-7 h-7 md:w-10 md:h-10 text-pet-pink shrink-0" />
        </div>
      </VelocityMarquee>
    </div>
    <div className="relative rotate-[2.5deg] scale-[1.06] mt-2 md:-mt-1 bg-pet-pink text-pet-pink-ink py-2.5 md:py-3.5">
      <VelocityMarquee baseVelocity={1.6}>
        <div className="font-display text-lg md:text-2xl leading-none">
          <Row items={VALUES} Icon={Heart} iconClass="w-5 h-5 md:w-6 md:h-6 text-white shrink-0" />
        </div>
      </VelocityMarquee>
    </div>
  </section>
);

export default Marquee;
